import { render } from "./CursorFollow.vue?vue&type=template&id=612e6d2a&ts=true"
import script from "./CursorFollow.vue?vue&type=script&lang=ts"
export * from "./CursorFollow.vue?vue&type=script&lang=ts"

import "./CursorFollow.vue?vue&type=style&index=0&id=612e6d2a&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__